import { css } from "@linaria/core";

import { MOBILE_MAX_SCREEN_SIZE } from "theme/antd";

export const compactBodyClassName = css`
  padding: var(--space-200) var(--space-300) !important;
`;

export const compactFooterClassName = css`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-100);

  padding: var(--space-150) !important;
  margin: 0 !important;

  @media screen and (max-width: ${MOBILE_MAX_SCREEN_SIZE}px) {
    flex-direction: column-reverse;
    gap: 8px;

    .ant6-btn + .ant6-btn {
      margin-inline-start: 0 !important;
    }
  }
`;

export const compactHeaderClassName = css`
  padding: var(--space-150) var(--space-300) !important;
`;

export const defaultBodyClassName = css`
  padding: var(--space-300) var(--space-400) !important;
`;

export const defaultFooterClassName = css`
  padding: 0 var(--space-300) var(--space-300) !important;
`;

export const defaultHeaderClassName = css`
  padding: var(--space-250) var(--space-500) !important;
`;

export const fullScreenBodyClassName = css`
  background-color: var(--white-color);
  border-radius: var(--radius-large);
  margin: var(--space-0) var(--space-200);
  padding: var(--space-200) !important;
`;

export const fullScreenContainerClassName = css`
  background-color: var(--page-background-color) !important;
  border-radius: 0 !important;

  min-height: 100vh;
  width: 100vw;
`;

export const fullScreenHeaderClassName = css`
  padding: var(--space-200) !important;
`;

export const fullScreenModalClassName = css`
  max-width: 100vw !important;
  margin: 0 !important;
  padding: 0 !important;
  top: 0;
`;

export const fullScreenFooterClassName = css`
  padding: 0 var(--space-200) !important;
`;
